import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { setIsLoginUser } from 'Store/User/actions';
import { fetchIsLoginUser } from 'Store/User/thunks';
import { setSelectedCustomerInfo } from 'Store/Order/actions';
import { getSelectedDeliveryCode, getSelectedCustomerInfo } from 'Store/Order/selectors';
import { getLoggedInUser, getIsLoggedIn, getIsLoginUser } from 'Store/User/selectors';
import FormCustomerInfo from 'Components/FormCustomerInfo/FormCustomerInfo';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';

interface IPropsInternal {
  isLoggedIn: boolean;
  isPasswordUser: boolean;
  deliveryCode: string;
  loggedInUser: Julius.Website.CustomerInfoViewModel;
  selectedCustomerInfo: Julius.Website.CustomerInfoViewModel;
  fetchIsLoginUser: (email: string) => void;
  setIsLoginUser: (isLoginCustomer: boolean, email: string) => void;
  setSelectedCustomerInfo: (customerInfo: Julius.Website.CustomerInfoViewModel) => void;
}

type Props = IPropsInternal;

interface IState {
  currentInput: Julius.Website.CustomerInfoViewModel;
  isValidEmail: boolean;
}

class FormCustomerInfoContainer extends React.PureComponent<Props, IState> {
  private formRef: HTMLFormElement;

  constructor(props: Props) {
    super(props);

    this.state = {
      currentInput: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        street: '',
        zipcode: '',
        city: '',
        country: '',
        company: '',
        locale: '',
        customerID: -1,
        isEmailsAllowed: false,
      },
      isValidEmail: false,
    }
  }

  componentDidMount() {
    const { loggedInUser, selectedCustomerInfo } = this.props;

    if (loggedInUser || selectedCustomerInfo) {
      const currentInput = selectedCustomerInfo ? 
        { ...selectedCustomerInfo } : { ...loggedInUser };

      this.setState({  currentInput }, 
        () => this.validateAndSaveFormData());
    }

    if (!loggedInUser) {
      this.props.setIsLoginUser(false, null);
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    const prevUser = this.props.loggedInUser;
    const nextUser = nextProps.loggedInUser;

    if (nextUser !== prevUser && nextProps.isLoggedIn) {
      this.setState({ 
        currentInput: { ...nextUser },
      }, () => this.validateAndSaveFormData());
    }
  }

  onChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { currentTarget, currentTarget: { name, value } } = e;
    const newInput = { ...this.state.currentInput, [name]: value };

    const newIsValidEmail = name === 'email' ?
      currentTarget.checkValidity() : this.state.isValidEmail;
    
    this.setState({ 
      isValidEmail: newIsValidEmail, 
      currentInput: newInput,
    }, () => this.validateAndSaveFormData());
  }

  onCountryChange = (value: string) => {
    this.setState({
      currentInput: { 
        ...this.state.currentInput, 
        country: value,
      },
    }, () => this.validateAndSaveFormData());
  }

  onEmailsAllowedChange = (isChecked: boolean) => {
    this.setState({ 
      currentInput: { 
        ...this.state.currentInput, 
        isEmailsAllowed: isChecked,
      },
    }, () => this.validateAndSaveFormData());
  }

  onEmailBlur = (e: React.FormEvent<HTMLInputElement>) => {
    const { isValidEmail, currentInput: { email } } = this.state;

    if (isValidEmail) {
      this.props.fetchIsLoginUser(email);
      return;
    } 
    
    if (this.props.isPasswordUser) {
      this.props.setIsLoginUser(false, null);
    }
  }

  validateAndSaveFormData = () => {
    const isValidInput = this.formRef.checkValidity();
    const customerInfo = isValidInput ? this.state.currentInput : null;
    this.props.setSelectedCustomerInfo(customerInfo);
  }

  setFormRef = (node: HTMLFormElement) => {
    this.formRef = node;
  }

  render() {
    return (
      <WrapperBox>
        <FormCustomerInfo
          isLoggedIn={ this.props.isLoggedIn }
          isShowingLoginHint={ this.props.isPasswordUser && !this.props.isLoggedIn }
          currentInput={ this.state.currentInput }
          deliveryCode={ this.props.deliveryCode }
          onChange={ this.onChange }
          onCountryChange={ this.onCountryChange }
          onEmailsAllowedChange={ this.onEmailsAllowedChange }
          onEmailBlur={ this.onEmailBlur }
          setFormRef={ this.setFormRef }
        />
      </WrapperBox>
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isLoggedIn: getIsLoggedIn(state),
    isPasswordUser: getIsLoginUser(state),
    loggedInUser: getLoggedInUser(state),
    deliveryCode: getSelectedDeliveryCode(state),
    selectedCustomerInfo: getSelectedCustomerInfo(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    setSelectedCustomerInfo,
    setIsLoginUser,
    fetchIsLoginUser,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(FormCustomerInfoContainer);


// WEBPACK FOOTER //
// ./src/components/FormCustomerInfo/FormCustomerInfoContainer.tsx